import { Outlet } from 'react-router-dom';
import './index.less';
import { useEffect } from 'react';

import { LoginProvider } from '@/context/LoginContext';
import { useLoginState } from '@/components/layouts/account/state/login';

export default function AccountLayout() {
  useEffect(() => {
    if (new URLSearchParams(window.location.search).get('utm_source')) {
      sessionStorage.setItem(
        'source',
        new URLSearchParams(window.location.search).get('utm_source'),
      );
    }
    if (new URLSearchParams(window.location.search).get('utm_campaign')) {
      sessionStorage.setItem(
        'campaign',
        new URLSearchParams(window.location.search).get('utm_campaign'),
      );
    }
    if (new URLSearchParams(window.location.search).get('utm_term')) {
      sessionStorage.setItem('term', new URLSearchParams(window.location.search).get('utm_term'));
    }
    if (new URLSearchParams(window.location.search).get('utm_ad')) {
      sessionStorage.setItem('ad', new URLSearchParams(window.location.search).get('utm_ad'));
    }
    if (new URLSearchParams(window.location.search).get('recall')) {
      sessionStorage.setItem('recall', new URLSearchParams(window.location.search).get('recall'));
      window.onClickGATrackEvent('recall_visit', {
        promoCode: new URLSearchParams(window.location.search).get('recall'),
      });
    }
  }, []);
  return (
    <div className="account-layout">
      <div className="account_main">
        <LoginProvider value={{ ...useLoginState() }}>
          <Outlet></Outlet>
        </LoginProvider>
      </div>
    </div>
  );
}
